import React from 'react';
import moment from 'moment';
import { Box, Inline } from '@styleseat/ui';
import type { IProviderScheduleDayOpen, ProviderScheduleDay } from '../../../../store/ProviderWorkSchedule.types';
import {
  HeaderText,
  BodyText,
  Stack,
} from '../../../ui';

export type AboutBusinessHoursProps = {
  schedule: ProviderScheduleDay[];
  centered?: boolean;
};

const Text = props => (
  <BodyText appearance="small" weight="thin" {...props} />
);

/**
 * Renders Weekly Business Hours for a Provider/Salon
 * @example
 *
 * const MyComponent = () => {
 *   return (
 *     <BusinessHours
 *       schedule={arrayOfDays}
 *     />
 *   );
 * }
 */
export const AboutBusinessHours: React.FCWithChildren<AboutBusinessHoursProps> = ({
  schedule,
  centered,
}) => (
  <Stack space={4} alignItems={centered ? 'center' : undefined}>
    <HeaderText level="4" textAlign={centered ? 'center' : undefined}>Business Hours</HeaderText>

    <Inline space={8}>
      <Stack space={4}>
        {schedule?.map(entry => (
          <Box key={`day-${entry.day.toUTCString()}`}>
            <Text testID={`day-${moment(entry.day).format('dddd')}-header`}>
              {moment(entry.day).format('dddd')}:
            </Text>
          </Box>
        ))}
      </Stack>
      <Stack space={4}>
        {schedule?.map(entry => (
          <Box key={`hours=${entry.day.toUTCString()}`}>
            {entry.closed
              ? (<Text testID={`day-${moment(entry.day).format('dddd')}-value`}>Closed</Text>)
              : (
                <Inline testID={`day-${moment(entry.day).format('dddd')}-value`}>
                  <Text>{moment((entry as IProviderScheduleDayOpen).startTime).format(' h:mm A')}</Text>
                  <Text>-</Text>
                  <Text>{moment((entry as IProviderScheduleDayOpen).endTime).format(' h:mm A')}</Text>
                </Inline>
              )}
          </Box>
        ))}
      </Stack>
    </Inline>
  </Stack>
);

export default AboutBusinessHours;
